import { useContext } from 'react';
import { ComponentContext } from './ComponentContext';

export const useComponentContext = () => {
  const context = useContext(ComponentContext);
  if (!context) {
    throw new Error('useComponentContext must be used within a ComponentProvider');
  }
  return context;
};
